// prettier-ignore
export const US_PRODUCTS = [
  {
    id: "fsm",
    title: "Field Service Management",
    subtitle: ({ per_license }) => `<input>$${per_license}</input> per user`,
    entity_name: "user",
    has_annual_discount: true,
    base: 0,
    base_licenses: 0,
    min_licenses: 1,
    per_license: 99,
    default_enabled: true,
  },
  {
    id: "limited_agent",
    title: "Limited Agent Users",
    subtitle: ({ per_license }) => `<input>$${per_license}</input> per user`,
    entity_name: "user",
    has_annual_discount: true,
    base: 0,
    base_licenses: 0,
    min_licenses: 1,
    per_license: 30,
    hidden: true
  },
  {
    id: "engage_legacy",
    title: "Engage Phone System",
    subtitleBase: ({ base }) => `<input>$${base}</input> + `,
    subtitle: ({ per_license }) => `<input>$${per_license}</input> per additional line`,
    entity_name: "line",
    has_annual_discount: false,
    base: 120,
    base_licenses: 5,
    min_licenses: 0,
    per_license: 5,
    hidden: true
  },
  {
    id: "engage_phone_system",
    title: "Engage Phone System",
    subtitleBase: ({ base }) => `<input>$${base}</input> per month (5 users)`,
    subtitle: ({ per_license }) => `<input>$${per_license}</input> per additional user`,
    entity_name: "user",
    has_annual_discount: false,
    base: 125,
    base_licenses: 5,
    min_licenses: 0,
    per_license: 25,
  },
  {
    id: "engage_phone_system_additional_line",
    subtitle: ({ per_license }) => `<input>$${per_license}</input> per additional line`,
    entity_name: "line",
    has_annual_discount: false,
    base: 0,
    base_licenses: 0,
    min_licenses: 1,
    per_license: 5,
    hidden: true,
  },
  {
    id: "operator_ai_minute",
    title: "Operator AI",
    subtitle: ({ per_license }) => `<input>$${per_license}</input> per additional minute`,
    entity_name: "minute",
    has_annual_discount: false,
    base: 0,
    base_licenses: 0,
    min_licenses: 60,
    per_license: 3,
  },
  {
    id: "chat_ai",
    title: "Chat AI",
    subtitleBase: ({ base }) => `<input>$${base}</input> per month`,
    has_annual_discount: false,
    base: 200,
    base_licenses: 0,
    min_licenses: 1,
    per_license: 0,
  },
  {
    id: "sales_suite",
    title: "Sales Suite",
    subtitleBase: ({ base }) => `<input>$${base}</input> per month`,
    has_annual_discount: true,
    base: 100,
    base_licenses: 0,
    min_licenses: 1,
    per_license: 0,
  },
  {
    id: "custom_forms",
    title: "Custom Forms",
    subtitleBase: ({ base }) => `<input>$${base}</input> per month`,
    has_annual_discount: true,
    base: 100,
    base_licenses: 0,
    min_licenses: 1,
    per_license: 0,
  },
  {
    id: "pdf_form",
    title: "PDF Form Filler",
    subtitleBase: ({ base }) => `<input>$${base}</input> per month`,
    annual_only: false,
    has_annual_discount: true,
    base: 50,
    base_licenses: 0,
    min_licenses: 0,
    per_license: 0,
    hidden: true
  },
  {
    id: "fleet_management",
    title: "Fleet Management",
    subtitle: ({ per_license }) => `$${per_license} per vehicle`,
    entity_name: "vehicle",
    has_annual_discount: false,
    base: 0,
    base_licenses: 0,
    min_licenses: 1,
    per_license: 30,
  },
  {
    id: "fleet_tracking",
    title: "GPS Fleet Tracking",
    subtitle: ({ per_license }) => `<input>$${per_license}</input> per vehicle`,
    entity_name: "vehicle",
    has_annual_discount: false,
    base: 0,
    base_licenses: 0,
    min_licenses: 1,
    per_license: 30,
  },
  {
    id: "fleet_cameras",
    title: "AI Fleet Cameras",
    subtitle: ({ per_license }) => `<input>$${per_license}</input> per vehicle`,
    entity_name: "vehicle",
    has_annual_discount: false,
    base: 0,
    base_licenses: 0,
    min_licenses: 1,
    per_license: 60,
  },
  {
    id: "premium_support",
    title: "Premium Support",
    has_annual_discount: false,
    base: 795 / 12,
    base_licenses: 0,
    min_licenses: 0,
    per_license: 0,
    default_enabled: true,
  },
];

export const AUS_PRODUCTS = [];
